import { render, staticRenderFns } from "./OrderSummaryBody.vue?vue&type=template&id=56ea40c4&scoped=true&"
import script from "./OrderSummaryBody.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryBody.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummaryBody.vue?vue&type=style&index=0&id=56ea40c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea40c4",
  null
  
)

export default component.exports